import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type BaseRouteDefinition = `${typeof baseRoute}/subCategory/${number | ':subCategoryId'}/equipment`;

type QueryRouteDefinition = `${typeof baseRoute}/subCategory/${number | ':subCategoryId'}/equipment${`?year=${string}` | ''}`;

type RouteDefinition = BaseRouteDefinition | QueryRouteDefinition;

export const ROUTE: RouteDefinition = `${baseRoute}/subCategory/:subCategoryId/equipment`;

export const URL = (subCategoryId: number, year?: string): RouteDefinition => year
	? `${baseRoute}/subCategory/${subCategoryId}/equipment?year=${year}`
	: `${baseRoute}/subCategory/${subCategoryId}/equipment`;
